import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { CaseStudy } from './components/CaseStudy';
import { Process } from './components/Process';
import { Qualification } from './components/Qualification';
import { ApplicationForm } from './components/ApplicationForm';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-ink text-cream font-sans font-light selection:bg-gold selection:text-ink" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Process data-id="element-4" />
        <Qualification data-id="element-5" />
        <CaseStudy data-id="element-6" />
        <ApplicationForm data-id="element-7" />
      </main>
      <Footer data-id="element-8" />
    </div>;
}